import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import axios from 'axios';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import HeaderPage from '../components/HeaderPage';
import { useBlogContext } from '../../fetchdata/BlogContext';
import LoadingScreen from '../components/LoadingScreen';
import axiosInstance from '../../axiosInstance';
import getDecryptData from '../../helper/getDecryptData';
import { useNavigate } from 'react-router-dom';

const RateCalculator = () => {
  const navigate = useNavigate();

  const { Headers, isHeader, IsUserData, dataAuth } = useBlogContext();


  const [inputs, setInputs] = useState({
    image: null,
    weight: '',
    priceRange: '',
    deliveryDate: ''
  });


  const [selectedDate, setSelectedDate] = useState(null);
  const [minDate, setMinDate] = useState(new Date());

  const [goldPrice, setGoldPrice] = useState(null); // Gold price per ounce in USD
  const [silverPrice, setSilverPrice] = useState(null); // Silver price per ounce in USD
  const [usdToInrRate, setUsdToInrRate] = useState(0); // USD to INR conversion rate
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedMetal, setSelectedMetal] = useState('gold'); // Default is gold
  const [selectedCarat, setSelectedCarat] = useState(22); // default 22K

  const handleCaratChange = (e) => {
    setSelectedCarat(Number(e.target.value));
  };


  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    let newValue;

    if (type === 'file') {
      newValue = files[0];
    } else {
      newValue = value;
    }

    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setInputs((prev) => ({ ...prev, deliveryDate: date }));
  };

  const handleMetalChange = (e) => {
    setSelectedMetal(e.target.value);
  };
  const [SubmitLoading, setSubmitLoading] = useState(false); // Add loading state

  const handleSubmit = async () => {

    const fields = [
      { name: "image", message: "Please choose Image" },
      { name: "weight", message: "Please enter weight" },
    ];

    for (const field of fields) {
      if (!inputs[field.name]) {
        toast.error(field.message);
        setSubmitLoading(false);
        return;
      }
    }

    if (!selectedMetal) {
      toast.error('Please Choose Metal Type');
      setSubmitLoading(false);
      return;
    }

    if (!selectedDate) {
      toast.error('Please Choose Date');
      setSubmitLoading(false);
      return;
    }

    const decryptdatajson = await getDecryptData();
    const id = decryptdatajson?._id;


    const final = {
      ...inputs,
      userId: id,
      type: 1,
      order: 2,
      totalAmount: Math.round(totalPrice * 1.5),
      totalPrice: Math.round(totalPrice * 1.5),
      metal: selectedMetal,
      mode: 'Online',
      satus: 1,
      details: 'details',
      payment: 0,
      shipping: 0,
      selectedDate
    }
    try {
      setSubmitLoading(true);
      const { data } = await axiosInstance.post(
        `/create-custom-order/${id}`,
        final,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const { success } = data;

      if (success) {
        toast.success('Custom order created successfully!')
        navigate('/account/all-order');
      }
      console.log('datadata', data);

    } catch (err) {
      console.error("Error on creating order:", err);
      toast.error("Error on creating order");
    } finally {
      setSubmitLoading(false);
    }

    // e.preventDefault();
    // toast.success('Custom Order submitted successfully!');
  };

  const calculatePrice_old = () => {
    const weightInGrams = parseFloat(inputs.weight);
    const gst = Headers?.gst ?? 0; // Example GST rate (can be fetched from context or headers)
    const makingCharge = Headers?.makingCharge || 0; // Example making charge (can be fetched from context or headers)

    if (selectedMetal === 'gold' && goldPrice && usdToInrRate && weightInGrams > 0) {
      const basePriceINR = weightInGrams * goldPrice;
      const gstAmount = basePriceINR * (gst / 100);
      const makingChargeAmount = basePriceINR * (makingCharge / 100);
      const finalPriceINR = basePriceINR + gstAmount + makingChargeAmount;
      setTotalPrice(finalPriceINR);
    } else if (selectedMetal === 'silver' && silverPrice && usdToInrRate && weightInGrams > 0) {
      const basePriceINR = weightInGrams * silverPrice;
      const gstAmount = basePriceINR * (gst / 100);
      const makingChargeAmount = basePriceINR * (makingCharge / 100);
      const finalPriceINR = basePriceINR + gstAmount + makingChargeAmount;
      setTotalPrice(finalPriceINR);
    }
  };

  const calculatePrice_old_14jan25 = () => {
    const weightInGrams = parseFloat(inputs.weight);
    const gst = Headers?.gst ?? 0;
    const makingCharge = Headers?.makingCharge || 0;

    // convert 24K rate → 22K rate
    const goldPrice22K = goldPrice ? (goldPrice * 22) / 24 : 0;

    if (selectedMetal === "gold" && goldPrice22K && weightInGrams > 0) {
      const base = weightInGrams * goldPrice22K;
      const gstAmt = base * (gst / 100);
      const mcAmt = base * (makingCharge / 100);
      setTotalPrice(base + gstAmt + mcAmt);
    }

    if (selectedMetal === "silver" && silverPrice && weightInGrams > 0) {
      const base = weightInGrams * silverPrice;
      const gstAmt = base * (gst / 100);
      const mcAmt = base * (makingCharge / 100);
      setTotalPrice(base + gstAmt + mcAmt);
    }
  };


  const calculatePrice = () => {
    const weight = parseFloat(inputs.weight);
    if (!weight || weight <= 0) return;

    const gst = Headers?.gst ?? 0;
    const makingCharge = Headers?.makingCharge || 0;

    if (selectedMetal === "gold" && goldPrice) {
      // 24K → Selected Carat
      const goldPriceByCarat = (goldPrice * selectedCarat) / 24;

      const base = weight * goldPriceByCarat;
      const gstAmt = base * (gst / 100);
      const mcAmt = base * (makingCharge / 100);

      setTotalPrice(base + gstAmt + mcAmt);
    }

    if (selectedMetal === "silver" && silverPrice) {
      const base = weight * silverPrice;
      const gstAmt = base * (gst / 100);
      const mcAmt = base * (makingCharge / 100);

      setTotalPrice(base + gstAmt + mcAmt);
    }
  };


  useEffect(() => {
    dataAuth();
    // fetchPrices();
  }, []);
  useEffect(() => {

    if (!Headers?.gold || !Headers?.sliver) return;

    const gold10gm = Number(Headers.gold);     // Gold 10gm price (24KT)
    const silver10gm = Number(Headers.sliver); // Silver 10gm price

    const goldPerGram = gold10gm / 10;
    const silverPerGram = silver10gm / 10;

    setGoldPrice(goldPerGram);
    setSilverPrice(silverPerGram);

  }, [Headers]);



  // useEffect(() => {
  //   if (IsUserData) {
  //     if (IsUserData.profile !== '') {
  //       // fetchPrices();
  //     } else {
  //       navigate('/account/profile');
  //       toast.error('Complete your profile first!');
  //     }
  //   }
  // }, [IsUserData]);



  useEffect(() => {
    if (Headers?.customTime) {
      const today = new Date();
      today.setDate(today.getDate() + Headers.customTime);
      setMinDate(today); // Set the default minDate as today + customTime
    }
  }, [Headers?.customTime]);

  // useEffect(() => {
  //   calculatePrice();
  // }, [inputs.weight, selectedMetal, goldPrice, silverPrice, usdToInrRate]);

  useEffect(() => {
    calculatePrice();
  }, [inputs.weight, selectedMetal, selectedCarat, goldPrice, silverPrice]);


  const [isTableVisible, setIsTableVisible] = useState(false);

  // Handle toggle click
  const toggleTableVisibility = () => {
    setIsTableVisible((prev) => !prev);
  };


  return (
    <>
      <HeaderPage title={'Rate Calculator'} />
      <main className="page-content bg-white mypadding overflow-auto pb-4 px-0">
        <div className="px-3">
          {isHeader ? <LoadingScreen /> :
            <div className="mt-4">
              <div className="custom-order-form">


                <div className="form-group mb-3">
                  <label htmlFor="weight" className='mb-1'>Enter Weight (in grams)</label>
                  <div className="position-relative">
                    <input
                      type="number"
                      id="weight"
                      name="weight"
                      value={inputs.weight}
                      onChange={handleChange}
                      className="form-control"
                      min="1"
                      required
                    />
                    <span className='small position-absolute end-0 top-0 p-2 bg-primary text-white rounded-sm text-center' style={{ zIndex: 3, margin: '8px 5px', minWidth: 35 }}>
                      GM
                    </span>
                  </div>
                </div>

                <div className="form-group mb-3">
                  <label>Select Metal Type</label>
                  <div className='mt-2'>
                    <label className="me-3 border-info d-inline-flex align-items-center gap-2 border rounded p-2">
                      <input
                        type="radio"
                        name="metal"
                        value="gold"
                        checked={selectedMetal === 'gold'}
                        onChange={handleMetalChange}
                        className='text-success'

                      />
                      Gold
                    </label>
                    <label className="border-info d-inline-flex align-items-center gap-2 border rounded p-2">
                      <input
                        type="radio"
                        name="metal"
                        value="silver"
                        checked={selectedMetal === 'silver'}
                        onChange={handleMetalChange}
                        className='text-success'
                      />
                      Silver
                    </label>
                  </div>
                </div>


                {selectedMetal === "gold" && (
                  <div className="form-group mb-3">
                    <label className="mb-1">Select Gold Carat</label>
                    <div className="d-flex flex-wrap gap-2 mt-2">

                      {[14, 16, 18, 20, 22].map((carat) => (
                        <label
                          key={carat}
                          className="border-info d-inline-flex align-items-center gap-2 border rounded px-3 py-2"
                        >
                          <input
                            type="radio"
                            name="goldCarat"
                            value={carat}
                            checked={selectedCarat === carat}
                            onChange={handleCaratChange}
                          />
                          {carat}K
                        </label>
                      ))}

                    </div>
                  </div>
                )}


                <div className="form-group mb-3">

                  <div className="w-100 rounded p-2 shadow-sm border col" style={{ backgroundColor: '#f8f9fa', margin: 'auto' }}>
                    <div className="d-flex justify-content-between mb-2 text-truncate ">
                      <h5 className="text-primary text-truncate"
                        onClick={toggleTableVisibility} // Toggle the table on click

                        style={{ fontWeight: 'bold', fontSize: '1rem' }}>Total Price  <i className="ri-question-line" /> </h5>


                      <span className="badge bg-success text-white text-truncate" style={{ fontSize: '1.1rem', fontWeight: '100' }}>
                        ₹{Math.round(totalPrice)} - ₹{Math.round(totalPrice * 1.3)}
                      </span>
                    </div>


                    {isTableVisible && <></>}
                    <div className="mt-3 position-relative">

                      {/* <div className='text-end mb-2'>
                          <button onClick={toggleTableVisibility} className='btn btn-danger btn-sm p-2 me-auto'>
                            Close
                          </button>
                        </div> */}

                      {/* <table className="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th>Details</th>
                            <th>Percentage</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>GST Included</td>
                            <td>{Headers?.gst}%</td>
                          </tr>
                          <tr>
                            <td>Making Charge Included</td>
                            <td>{Headers?.makingCharge}%</td>
                          </tr>
                        </tbody>
                      </table> */}
                    </div>


                    <p className="text-muted mb-0 " style={{ fontSize: '0.875rem', lineHeight: '1.4' }}>
                      Estimated based on the latest gold or silver price, including GST and making charges.                    </p>
                  </div>
                </div>







              </div>
            </div>
          }

        </div >

      </main >

    </>
  );
};

export default RateCalculator;
